import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

function getStorageUrl() {
    return "https://usepfe.blob.core.windows.net/usep-media-large/";
}

function getUrinaryStoneSize(stoneSizeInMilimeters: number) {
    var size = "3";
    if (stoneSizeInMilimeters < 5) size = "1";
    else if (stoneSizeInMilimeters < 10) size = "2";
    return size;
}

export const getUrinarySystemBackground = () => {
    var urinarySystemBackground = getStorageUrl();
    urinarySystemBackground += "background.png";
    return urinarySystemBackground;
}

export const getUrinarySystemBackgroundNo = (ableToExpel: number, stonePosition: number, stoneSize: number) => {
    var urinarySystemBackgroundNo = "";
    if (ableToExpel === 0) {
        urinarySystemBackgroundNo = getStorageUrl();
        urinarySystemBackgroundNo += "no-pos";
        urinarySystemBackgroundNo += stonePosition.toString();
        urinarySystemBackgroundNo += "-size";
        urinarySystemBackgroundNo += getUrinaryStoneSize(stoneSize);
        urinarySystemBackgroundNo += "-background.png";
    }
    return urinarySystemBackgroundNo;
}

export const getUrinarySystemIllustration = (ableToExpel: number, stonePosition: number, stoneSize: number) => {
    var urinarySystemIllustration = getStorageUrl();
    if (ableToExpel === 0) {
        urinarySystemIllustration += "no-pos";
        urinarySystemIllustration += stonePosition.toString();
        urinarySystemIllustration += ".gif";
    }
    else {
        urinarySystemIllustration += "yes-pos";
        urinarySystemIllustration += stonePosition.toString();
        urinarySystemIllustration += "-size";
        urinarySystemIllustration += getUrinaryStoneSize(stoneSize);
        urinarySystemIllustration += ".gif";
    }
    return urinarySystemIllustration;
}

export const showProbabilityToExpel = (ableToExpel: number, probabilityToExpel: number) => {
    var show = true;
    if (ableToExpel === 0) {
        if (probabilityToExpel > 0.5) {
            show = false;
        }
    }
    else {
        if (probabilityToExpel < 0.75) {
            show = false;
        }
    }
    return show;
}

export const getPredictionResultsTextColor = (ableToExpel: number) => {
    return ableToExpel === 0 ? '#8d003a' : '#3a8d00'; 
}

export const TypographyPredictionToExpel = ({ ableToExpel, stoneSizeInMilimeters } : { ableToExpel : number, stoneSizeInMilimeters: number }) => {
    const { t } = useTranslation();
    var color = getPredictionResultsTextColor(ableToExpel);
    var translationText = ableToExpel === 0 ? 'translations:PREDICTION_RESULTS_EXPEL_NO_SUCCESS' : 'translations:PREDICTION_RESULTS_EXPEL_SUCCESS';
    return (
        <Typography color={color} variant="h6" display="block" gutterBottom fontWeight="bold">
            {t(translationText, { size: stoneSizeInMilimeters })}
        </Typography>
    )
}

export const TypographyProbabilityToExpel = ( {ableToExpel, probabilityToExpel } : { ableToExpel: number, probabilityToExpel: number }) => {
    const { t } = useTranslation();
    var showProbability = showProbabilityToExpel(ableToExpel, probabilityToExpel);
    var color = getPredictionResultsTextColor(ableToExpel);
    return (
        showProbability ?
        <Typography color={color} variant="h6" display="block" gutterBottom fontWeight="bold">
            {t('translations:PREDICTION_RESULTS_EXPEL_PROBABILITY', { rate: (probabilityToExpel * 100).toFixed(2) })}
        </Typography>
        :
        <></>
    )
}

export const TypographyMaximalStone = ( {maximalStoneSizeToExpel, maximalStoneSizeProbabilityToExpel} : { maximalStoneSizeToExpel : number, maximalStoneSizeProbabilityToExpel : number }) => {
    const { t } = useTranslation();
    var color = "darkgray";
    return (
        maximalStoneSizeToExpel === 0.0 && maximalStoneSizeProbabilityToExpel === 0.0 ?
        <>
            <Typography color={color} variant="h6" display="block" gutterBottom fontWeight="bold">
                {t('translations:PREDICTION_RESULTS_EXPEL_MAXIMAL_STONE_IMPOSSIBLE')}
            </Typography>
        </>
        :
        <>
            <Typography color={color} variant="h6" display="block" gutterBottom fontWeight="bold">
                {t('translations:PREDICTION_RESULTS_EXPEL_MAXIMAL_STONE', { stonesize: maximalStoneSizeToExpel })}
            </Typography>
            <Typography color={color} variant="h6" display="block" gutterBottom fontWeight="bold">
                {t('translations:PREDICTION_RESULTS_EXPEL_MAXIMAL_STONE_PROBABILITY', { rate: (maximalStoneSizeProbabilityToExpel * 100).toFixed(2) })}
            </Typography>
        </>
    )
}